import { InputNumber } from "antd";
import styled from "styled-components";

import colors from "../../../../../css/colors";

interface InputWrapperProps {
  minHeight?: number;
  disabled?: boolean;
}

export const InputWrapper = styled.div<InputWrapperProps>`
  display: flex;
  flex: 1;
  flex-direction: column;

  input {
    font-size: 16px !important;
    border-radius: 6px;
  }

  .ant-input-disabled {
    background: ${colors.GREY_BACKGROUND};
  }

  .ant-input-number {
    border-radius: 6px;
  }

  textarea {
    border-radius: 6px;
    font-size: 16px !important;
    min-height: ${(props) => (props.minHeight ? `${props.minHeight}px` : "initial")};
    resize: none;
    background-color: ${(props) => (props.disabled ? colors.GREY_BACKGROUND : "initial")};
  }
`;

interface LabelProps {
  dimension?: boolean;
}

export const Label = styled.div<LabelProps>`
  display: flex;
  justify-content: ${(props) => (props.dimension ? "flex-end" : "inherit")};
  margin: 0 0 2px;
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => (props.dimension ? colors.GREY : colors.GREY_DARK)};
`;

export const RedText = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${colors.RED};
`;

interface TextProps {
  color?: string;
  fontWeight?: number;
}

export const Text = styled.div<TextProps>`
  font-size: 16px;
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 600)};
  color: ${(props) => (props.color ? props.color : colors.CHARCOAL)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
`;

export const DaysBeforeExpiryWrapper = styled.div`
  flex-direction: column;
  max-width: 96px;
`;

export const DaysBeforeExpiryInputNumber = styled(InputNumber)`
  width: 96px;
  margin-top: 8px;

  .ant-input-number-handler-wrap {
    display: none;
  }
`;
